<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card tab2-card">
                <div class="card-header">
                    <h5> Usuarios</h5>
                </div>

                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="input-group mb-3">
                                <input type="text" class="form-control" placeholder="Buscar usuario..."
                                    aria-label="Buscar usuario" aria-describedby="button-addon2">
                                <button class="btn btn-outline-secondary" type="button"
                                    id="button-addon2">Buscar</button>
                            </div>
                        </div>
                        <div class="col-sm-6 text-end">
                            <button class="btn btn-primary"
                                >Agregar</button>
                        </div>
                    </div>
                    <div class="">
                     
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

